

























































































































































































































































































































































import {
	AccountTypeEnum,
	ApplicationUserModel,
	CatalogueItemModel,
	PartyModel,
	PartyWorkDayModel,
	PartyWorkDayUserModel,
	TenantModel,
	TenantUserModel,
	UnitOfMeasureModel,
	WorkTaskModel,
	WorkTaskRuleModel,
	WorkTaskStatementModel
} from '@/libs/Api';
import {CrudAction, CrudReponse} from '@/libs/core/+state/models/crud-action';
import {CrudGetter} from '@/libs/core/+state/models/crud-getter';
import {createCrudQueryPayload} from '@/libs/core/+state/models/crud-query-payload';
import {partiesStore} from '@/libs/parties/+state/store';
import {workTaskRulesStore} from '@/libs/work-task-rules/+state/store';
import Page from '@/Page.vue';
import moment from 'moment';
import {Component, Prop, Ref, Watch} from 'vue-property-decorator';
import {workTasksStore} from '../+state/store';
import WorkTaskDialogItem from '../components/WorkTaskDialogItem.vue';
import WorkTaskCloseDialog from '../components/WorkTaskCloseDialog.vue';
import {applicationUserStore} from '@/libs/user-settings/+state/store';
import {Guid} from '@/libs/common/functions/guid';
import {catalogueItemsStore} from '@/libs/catalogue-items/+state/store';
import {unitsOfMeasureStore} from '@/libs/units-of-measure/+state/store';
import {distance} from 'fastest-levenshtein';
import WorkTaskRuleDialog from '@/libs/parties/components/WorkTaskRuleDialog.vue';
import {Constants} from '@/constants';
import {partyWorkDaysStore} from '@/libs/party-work-days/+state/store';
import {cloneDeep} from 'lodash';
import {authStore} from '@/libs/auth/+store/store';
import {AuthGetter} from '@/libs/auth/models/auth-state';
import {tenantsStore} from '@/libs/tenants/+state/store';
import WorkTaskRuleCreateDialog from '@/libs/parties/components/WorkTaskRuleCreateDialog.vue';
import accentInsensitiveSearch from 'accent-insensitive-search';

@Component({
    components: {
		WorkTaskRuleCreateDialog,
        WorkTaskDialogItem,
        WorkTaskCloseDialog,
        WorkTaskRuleDialog
    }
})
export default class WorkTaskDialog extends Page {

    id: string = Guid.EmptyGuid();
    partyId = '';
    day!: string;
    dialog = false;
    valid = true;
    saving = false;
	deleting = false;
	deleteDialog = false;
    changed = false;
    unsavedDialog = false;
    partyWorkDay: PartyWorkDayModel | null = null;
    partyWorkDayUsers: Array<PartyWorkDayUserModel> = [];
    partyWorkDayUsersOriginal: Array<PartyWorkDayUserModel> = [];
    catalogueItems: Array<CatalogueItemModel> = [];
    workTaskRules: Array<WorkTaskRuleModel> = [];
    workTasks: Array<WorkTaskModel> = [];
    workTaskStatements: Array<WorkTaskStatementModel> = [];
    waitingWorkTasks: Array<WorkTaskModel> = [];
    searchValue = "";
    applicationUser: ApplicationUserModel = applicationUserStore.useGetter(CrudGetter.Detail) as ApplicationUserModel;
    finishedPercent = 0;
    possiblePartyWorkingTasks: Array<WorkTaskRuleModel> = [];
    filteredActivePossiblePartyWorkingTasks: Array<WorkTaskRuleModel> = [];
    filteredNewPossiblePartyWorkingTasks: Array<WorkTaskRuleModel> = [];
    possibleCatalogueItems: Array<CatalogueItemModel> = [];
    filteredPossibleCatalogueItems: Array<CatalogueItemModel> = [];
    reportedTotals: Array<any> = [];
    closePlanItemDialog = false;
    saved = false;
    error = false;
    locking = false;
    unlocking = false;
    loadingData = false;
    loadingPartyWorkDay = false;
	partyPeriodLockedDialog = false;

    @Ref() workTaskRuleCreateDialog!: WorkTaskRuleCreateDialog;
    @Prop() tenantId!: string;

    get party() : PartyModel {
        return partiesStore.useGetter(CrudGetter.Detail, "WorkTaskDialog");
    }

    get waitingWorkTasksPercent (): number {
        const waiting = this.waitingWorkTasks.length ?? 0;
        const done = this.waitingWorkTasks.filter(x => x.isProvided == true).length ?? 0;
        const total = waiting + done;
        if (total > 0)
            return total > 0 ? Math.floor(waiting / total * 100) : 0;
        else
            return 50;
    }

    get canMarkIsDone (): boolean {
        return (this.partyWorkDay && this.partyWorkDay.isDone == false && this.workTasks && this.workTasks.length > 0 && this.workTasks.all(x => x.isProvided == true) && !this.closePlanItemDialog && !this.saving && !this.loading) ?? false;
    }

    get canUnlock (): boolean {
        return (this.partyWorkDay && this.partyWorkDay.isDone == true && !this.loading) ?? false;
    }

    get isLocked (): boolean {
        return (this.partyWorkDay?.isDone ?? false) || (this.partyWorkDay?.partyPeriod != null && this.partyWorkDay!.partyPeriod?.isLocked == true);
    }

    get loading (): boolean {
        return this.loadingData || this.loadingPartyWorkDay;
    }

    get canRecord (): boolean {
        if (this.partyWorkDay == null || moment(this.partyWorkDay?.day).isSameOrAfter(moment().add(1, "day").startOf("day"))) {
            return false;
        }
        return true;
    }

	get enableWorkTaskRuleCreate (): boolean {
		const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
		const tenant = tenantsStore.useGetter(CrudGetter.Detail, this.tenantId) as TenantModel;
		return tenantUser.accountType == AccountTypeEnum.Admin || tenantUser.accountType == AccountTypeEnum.Manager || (tenantUser.accountType == AccountTypeEnum.Worker && tenant.enableCreateWorkTaskRuleByWorker == true);
	}

    @Watch("searchValue")
    searchValueChanged () {
        this.filterPossible();
    }

    open (id: string, partyId: string, day: string) {
        this.partyWorkDayUsersOriginal = [];
        if (id == Guid.EmptyGuid()) {
			this.dialog = true;
			this.id = Guid.EmptyGuid();
			this.changed = false;
			this.partyId = partyId;
			this.day = day;
			this.loadParty().then((e: PartyModel) => {
				this.waitingWorkTasks = [];
				this.partyWorkDay = {
					id: Guid.EmptyGuid(),
					isDone: false,
					partyId: this.partyId,
					day: moment(day).format("YYYY-MM-DDT00:00:00"),
					doneWorkTasks: 0,
					remainingWorkTasks: 0,
					partyWorkDayUsers: e.partyCareProviders!.select(x => {
						return {
							userId: x.userId,
							user: x.user
						} as PartyWorkDayUserModel;
					}).toArray(),
					isUserDefined: true,
					isUserListCustomDefined: false
				} as PartyWorkDayModel;
				this.partyWorkDayUsers = this.partyWorkDay.partyWorkDayUsers!;
				this.loadCatalogueItems().then(() => {
					this.workTasks = [];
					this.loadWorkTaskRules().then(() => {
						this.make();
					});
				});
			});
        }
        else {
            this.dialog = true;
            this.changed = false;
            this.id = id;
            this.partyId = partyId;
            this.day = day;
            this.load();
        }
    }

    close () {
        if (!this.changed)
            this.dialog = false;
        else
            this.unsavedDialog = true;
    }

    private load () {
        this.loadingData = true;
        this.waitingWorkTasks = [];
        Promise.all([
            this.loadParty(),
            this.loadPartyWorkDay(),
            this.loadCatalogueItems(),
            this.loadWorkTaskRules()
        ]).then(() => {
            this.make();
            this.loadingData = false
        }).catch((e) => {
            this.loadingData = false;
            this.close();
            console.error(e);
        });
    }

    private loadPartyWorkDay (): Promise<any> {
        return new Promise((resolve, reject) => {
            partyWorkDaysStore.dispatch(CrudAction.Get, { id: this.id, key: "WorkTaskDialog" });
            this.subscribe(partyWorkDaysStore, CrudReponse.Get, "WorkTaskDialog").then((e: PartyWorkDayModel) => {
                this.partyWorkDay = e;
                this.partyWorkDayUsers = e.partyWorkDayUsers!;
                this.workTasks = e.workTasks!;
                resolve(e);
            }).catch((e: any) => {
                reject(e);
            });
        });
    }

    private loadParty (): Promise<PartyModel> {
        return new Promise<PartyModel>((resolve, reject) => {
			partiesStore.dispatch(CrudAction.Get, { id: this.partyId, key: "WorkTaskDialog" });
			this.subscribe(partiesStore, CrudReponse.Get, "WorkTaskDialog").then((e: PartyModel) => {
				resolve(e);
			}).catch(e => reject(e));
		});
    }

    private loadWorkTaskRules (): Promise<any> {
        return new Promise((resolve, reject) => {
            workTaskRulesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<WorkTaskRuleModel>(undefined, [
                {field: "partyId", op: "eq", comparand: this.partyId}
            ], undefined, false, "WorkTaskDialog"));
            this.subscribe(workTaskRulesStore, CrudReponse.GetAll, "WorkTaskDialog").then((e: WorkTaskRuleModel[]) => {
                this.workTaskRules = e;
                resolve(e);
            }).catch((e: any) => {
                reject(e);
            });
        });
    }

    private loadCatalogueItems (): Promise<any> {
        return new Promise((resolve, reject) => {
            catalogueItemsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<WorkTaskRuleModel>(undefined, [
            ], {
                pageIndex: 1,
                pageSize: 10
            }, false, "WorkTaskDialog"));
            this.subscribe(catalogueItemsStore, CrudReponse.GetAll, "WorkTaskDialog").then((e: CatalogueItemModel[]) => {
                this.catalogueItems = e;
                resolve(e);
            }).catch((e: any) => {
                reject(e);
            });
        });
    }

    make () {
        const canRecord = moment(this.partyWorkDay!.day).isBefore(moment().add(1, "day").startOf("day"));
        this.waitingWorkTasks = this.workTasks.orderBy(x => x.disablePerforming ?? false).thenBy(x => x.catalogueItem!.name).toArray();
        this.waitingWorkTasks.forEach((n: WorkTaskModel) => {
            if (canRecord && !n.workTaskStatements!.find(x => x.createdById == this.applicationUser.id) && n.workTaskStatements?.length == 0) {
                n.workTaskStatements!.push({
                    id: Guid.EmptyGuid(),
                    workTaskId: n.id,
                    visitNumber: 1,
                    amount: undefined,
                    userId: this.applicationUser.id,
                    user: this.applicationUser
                } as WorkTaskStatementModel);
            }
        });
        this.makePossible();
        this.finishedPercent = this.workTasks.length > 0 ? Math.round(this.waitingWorkTasks.filter(x => x.isProvided == true).length / this.workTasks.length * 100) : 100;
        const reportedUnitsOfMeasureId = [...new Set(this.workTasks.map((e: WorkTaskModel) => e.catalogueItem!.reportedUnitOfMeasureId!))];
        const unitsOfMeasure = unitsOfMeasureStore.useGetter(CrudGetter.Data) as UnitOfMeasureModel[];
        this.reportedTotals = unitsOfMeasure.filter(x => reportedUnitsOfMeasureId.indexOf(x.id!) >= 0).map((e: UnitOfMeasureModel) => {
            const filteredWorkTasks = this.workTasks.filter((n: WorkTaskModel) => n.workTaskRule?.catalogueItem?.reportedUnitOfMeasureId == e.id);
            return {
                unitOfMeasure: e,
                totalAmount:
                        filteredWorkTasks
                        .map(
                            (e: WorkTaskModel) => e.workTaskStatements?.map((n: WorkTaskStatementModel) => n.amount ?? 0).reduce((sum, current) => sum + current, 0) ?? 0
                        )
                        .reduce((s, c) => s + c, 0)
            }
        });
        this.filterPossible();
    }

    makePossible () {
        let existing: Array<string> = this.waitingWorkTasks.map((x: WorkTaskModel) => x.catalogueItemId!);
        this.possiblePartyWorkingTasks = this.workTaskRules.filter(x => !this.workTasks.find(n => n.workTaskRuleId == x.id) && existing.indexOf(x.catalogueItemId!) < 0);
        this.possibleCatalogueItems = this.catalogueItems.filter(x => !this.workTaskRules.find(n => n.catalogueItemId == x.id));
    }

    realodPossiblePartyWorkingTasks(): void {
        this.loadWorkTaskRules().then(() => {
            this.makePossible();
            this.filterPossible();
        });
    }

    filterPossible () {
        if (this.searchValue && this.searchValue.length > 0) {
			const searchValue = this.searchValue;
            this.filteredActivePossiblePartyWorkingTasks = this.possiblePartyWorkingTasks.filter((x: WorkTaskRuleModel) => x.workTaskStateId == Constants.WorkTaskRuleActiveId).filter((e: WorkTaskRuleModel) => {
				return accentInsensitiveSearch(searchValue.toLowerCase(), (e.catalogueItem?.name ?? "").toLowerCase());
            });
            this.filteredNewPossiblePartyWorkingTasks = this.possiblePartyWorkingTasks.filter((x: WorkTaskRuleModel) => x.workTaskStateId == Constants.WorkTaskRuleNewId).filter((e: WorkTaskRuleModel) => {
                return distance(searchValue, e.catalogueItem!.name!) >= 0;
            });
            this.filteredPossibleCatalogueItems = this.possibleCatalogueItems.filter((e: CatalogueItemModel) => {
                return distance(searchValue, e.name!) >= 0;
            });
        }
        else {
            this.filteredActivePossiblePartyWorkingTasks = this.possiblePartyWorkingTasks.filter((x: WorkTaskRuleModel) => x.workTaskStateId == Constants.WorkTaskRuleActiveId);
            this.filteredNewPossiblePartyWorkingTasks = this.possiblePartyWorkingTasks.filter((x: WorkTaskRuleModel) => x.workTaskStateId == Constants.WorkTaskRuleNewId);
            this.filteredPossibleCatalogueItems = this.possibleCatalogueItems;
        }
    }

    save (closeAfterSave: boolean) {
        this.saving = true;
        const items: any[] = [];
        this.waitingWorkTasks.forEach((e: WorkTaskModel) => {
            const item = cloneDeep(e);
            if (item.disablePerforming != true) {
                item.workTaskStatements = item.workTaskStatements?.filter(x => x.amount != null && x.amount.toString().length > 0 && Number(x.amount) > 0 && x.userId != null);
            }
            else {
                item.workTaskStatements = [];
            }
            items.push(item);
        });
        const partyWorkDay = cloneDeep(this.partyWorkDay!);
        partyWorkDay.workTasks = items;
        partyWorkDay.workTasks.forEach(x => {
            x.workTaskStatements = x.workTaskStatements?.where(n => n.amount != null && n.amount > 0).toArray();
            x.isProvided = (x.workTaskStatements && x.workTaskStatements.length > 0 && x.workTaskStatements!.sum(n => n.visitNumber ?? 0) >= (x.dayOccurrence ?? 0)) ?? false;
        });
        if (partyWorkDay.id == Guid.EmptyGuid()) {
            partyWorkDay.partyWorkDayUsers = this.partyWorkDayUsers;
            partyWorkDaysStore.dispatch(CrudAction.Create, { item: partyWorkDay });
            this.subscribe(partyWorkDaysStore, CrudReponse.Create).then((e: PartyWorkDayModel) => {
                this.id = e.id!;
                this.loadPartyWorkDay().then(() => {
                    if (this.partyWorkDay!.isDone == false && this.workTasks.all(x => x.isProvided == true || x.disablePerforming == true)) {
                        this.closePlanItemDialog = true;
                    }
                    this.make();
                    this.$emit("saved");
                    this.$emit("created", e);
                    this.saving = false;
                    this.changed = false;
                    this.saved = true;
                    if (closeAfterSave && !this.closePlanItemDialog)
                        this.dialog = false;
                }).catch(() => {
                    this.saving = false;
                    this.error = true;
                });
            }).catch((e) => {
				if (e?.serverMessage?.message == "PARTY_PERIOD_LOCKED") {
					this.partyPeriodLockedDialog = true;
				}
				else {
					this.error = true;
				}
				this.saving = false;
            });
        }
        else {
            partyWorkDay.partyWorkDayUsers = this.partyWorkDayUsers;
            partyWorkDaysStore.dispatch(CrudAction.Update, { item: partyWorkDay });
            this.subscribe(partyWorkDaysStore, CrudReponse.Update).then((e: PartyWorkDayModel) => {
                this.loadPartyWorkDay().then(() => {
                    if (this.partyWorkDay!.isDone == false && this.workTasks.all(x => x.isProvided == true || x.disablePerforming == true)) {
                        this.closePlanItemDialog = true;
                    }
                    this.make();
                    this.$emit("saved");
                    this.saving = false;
                    this.changed = false;
                    this.saved = true;
                    if (closeAfterSave && !this.closePlanItemDialog)
                        this.dialog = false;
                }).catch(() => {
                    this.saving = false;
                    this.error = true;
                });
            }).catch((e) => {
				if (e?.serverMessage?.message == "PARTY_PERIOD_LOCKED") {
					this.partyPeriodLockedDialog = true;
				}
				else {
					this.error = true;
				}
                this.saving = false;
            });
        }
    }

    public saveAllPromise (payload: Array<any>): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.saveAllPromisePop(payload, resolve, reject);
        });
    }

    private saveAllPromisePop(payload: Array<any>, resolve: (value: any) => void, reject: (reason?: any) => void) {
        if (payload.length > 0) {
            const payloadItem = payload[0];
            if (payloadItem.item.id == Guid.EmptyGuid())  {
                workTasksStore.dispatch(CrudAction.Create, payloadItem);
                this.subscribe(workTasksStore, CrudReponse.Create).then((e: any) => {
                    payload.shift();
                    this.saveAllPromisePop(payload, resolve, reject);
                }).catch((e: any) => {
                    reject(e);
                });
            }
            else {
                workTasksStore.dispatch(CrudAction.Update, payloadItem);
                this.subscribe(workTasksStore, CrudReponse.Update).then((e: any) => {
                    payload.shift();
                    this.saveAllPromisePop(payload, resolve, reject);
                }).catch((e: any) => {
                    reject(e);
                });
            }
        }
        else {
            resolve(null);
        }
    }

    reloadWorkTaskRules () {
        this.loadWorkTaskRules().then(() => {
            this.makePossible();
            this.filterPossible();
        })
    }

    createWorkTaskRule (item: CatalogueItemModel) {
		this.workTaskRuleCreateDialog.open(false);
    }

    createWorkTaskFromRuleClick (item: WorkTaskRuleModel) {
        const canRecord = moment(this.partyWorkDay!.day).isBefore(moment().add(1, "day").startOf("day"));
        this.waitingWorkTasks.push({
            id: Guid.EmptyGuid(),
            workTaskRuleId: item.id,
            workTaskRule: item,
            time: this.day,
            isProvided: false,
            partyWorkDayId: Guid.EmptyGuid(),
            catalogueItem: item.catalogueItem,
            catalogueItemId: item.catalogueItemId,
			isUserDefined: true,
            isLoweredUnitPrice: false,
            partyWorkDay: {
                id: Guid.EmptyGuid(),
                day: this.day,
                partyId: this.partyId,
				isUserDefined: true
            } as PartyWorkDayModel,
            workTaskStatements: canRecord ? [
                {
                    id: Guid.EmptyGuid(),
                    workTaskId:Guid.EmptyGuid(),
                    visitNumber: 1,
                    amount: undefined,
                    userId: this.applicationUser.id,
                    user: this.applicationUser
                } as WorkTaskStatementModel
            ] : [],
            disablePerforming: false
        } as WorkTaskModel);
        this.makePossible();
        this.filterPossible();
        this.changed = true;
    }

    goToLocation(item: PartyModel) {
        const n: Array<string | null> = [ item.street ?? null, item.city ?? null, item.zip ?? null ];
        const address = n.filter(x => x != null && x.length > 0).join(", ");
        window.open('https://google.com/maps/place/' + address, '_blank');
    }

    addPartyWorkDayUser () {
        this.partyWorkDayUsers.push({
            id: Guid.EmptyGuid(),
            userId: Guid.EmptyGuid()
        } as PartyWorkDayUserModel);
        this.changed = true;
    }

    getInitials (v: string) {
        let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');

        let initials: any = [...v.matchAll(rgx)] || [];

        initials = (
            (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
        ).toUpperCase();

        return initials;
    }

    markDone (v: boolean) {
        this.partyWorkDay!.isDone = v;
        this.saved = true;
        this.closePlanItemDialog = false;
        this.close();
    }

    showError () {
        this.error = true;
    }

    lock () {
        this.closePlanItemDialog = true;
    }

    unlock () {
        this.unlocking = true;
        const partyWorkDay = cloneDeep(this.partyWorkDay!);
        partyWorkDay.isDone = false;
        partyWorkDaysStore.dispatch(CrudAction.Update, { item: partyWorkDay });
        this.subscribe(partyWorkDaysStore, CrudReponse.Update).then(() => {
            this.unlocking = false;
            this.partyWorkDay!.isDone = false
        }).catch((e) => {
            this.$emit("error");
            console.log(e);
        })
    }

    makePartyWorkDayUsersByParty() {
        this.partyWorkDayUsersOriginal = cloneDeep(this.partyWorkDayUsers);
        const partyWorkDayUsers = this.party.partyCareProviders?.select(x => {
            return {
                id: Guid.EmptyGuid(),
                partyWorkDayId: this.partyWorkDay!.id,
                userId: x.userId,
                user: x.user
            } as PartyWorkDayUserModel;
        }).toArray() ?? [];
        const result = partyWorkDayUsers.filter((provider: PartyWorkDayUserModel) => {
            return provider.userId === this.party.mainCareProviderId;
        });
        if (this.party.mainCareProviderId && result.length === 0) {
            partyWorkDayUsers.push({
                id: Guid.EmptyGuid(),
                partyWorkDayId: this.partyWorkDay!.id,
                userId: this.party.mainCareProviderId,
                user: this.party.mainCareProvider
            });
        }
        this.partyWorkDayUsers = partyWorkDayUsers.orderBy(x => x.user!.displayName).toArray();
    }

    isUserListCustomDefinedChanged() {
        this.changed = true;

        if (this.partyWorkDay!.isUserListCustomDefined && this.partyWorkDayUsersOriginal.length > 0) {
            this.partyWorkDayUsers = cloneDeep(this.partyWorkDayUsersOriginal);
        }
    }

	deleteRecord() {
		this.deleteDialog = true;
	}

	deleteItem() {
		const partyWorkDay = this.partyWorkDay;
		this.deleting = true;
		partyWorkDaysStore.dispatch(CrudAction.Delete, { id: this.partyWorkDay!.id! });
		this.subscribe(partyWorkDaysStore, CrudReponse.Delete).then(() => {
			this.$emit("deleted", partyWorkDay);
			this.deleting = false;
			this.deleteDialog = false;
			this.close();
		})
	}

}
